import React from 'react';
import { useGetExamChargesContext } from '../context';
  

const studentFieldMappings = [
    {label : 'PSID' , keyName : 'psid' },
    {label : 'Name' , keyName : 'studentName' },
    {label : "Father's Name" , keyName : 'studentFatherName' },
    {label : 'Mobile Number' , keyName : 'studentMobileNumber' },
    {label : 'Email ID' , keyName : 'studentEmailId' },
    {label : 'City' , keyName : 'city' },
    {label : 'State' , keyName : 'state' },
    {label : 'Pincode' , keyName : 'pincode' },
    {label : 'Address' , keyName : 'address' },
]

export const DetailsCell = ({label , value}) => {
    return(
        <div className='d-flex flex-column'>
            <span className='detail-cell-label'>{label}</span>
            <span className='detail-cell-value'>{value}</span>
        </div>
    )
}


const StudentDetails = () => {
    const {studentBasicDetails} = useGetExamChargesContext();
    console.log('studentBasicDetails', studentBasicDetails)
    return ( 
        <div className='student-details-card'>
            <h2>Student Details</h2>
            <div className='student-details-grid'>
                {studentFieldMappings?.map(({label, keyName}) => 
                    <DetailsCell key={label} label={label} value={studentBasicDetails[keyName]}/>
                )}
                
            </div>

        </div>
     );
}
 
export default StudentDetails;